<script>
    import { Line, mixins} from 'vue-chartjs'
    const { reactiveProp } = mixins

    export default {
        name: "LineChartV1",
        extends: Line,
        props: ['options'],
        mixins: [reactiveProp],
        mounted () {
            console.log(this.chartdata)
            this.renderChart(this.chartData, this.options)
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/importables/LineChartV1.vue